"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initiativesJiraIssueAddSyncSlice = void 0;
const get_1 = require("../@async/get.js");
const xuder_1 = require("@sonar-software/xuder");
const name_1 = require("../name.js");
exports.initiativesJiraIssueAddSyncSlice = (0, xuder_1.createAddSyncSlice)({
    name: name_1.InitiativeJiraIssuesName,
    state: get_1.getInitiativesJiraIssueSlice.asyncState,
    transform: (action, state = []) => {
        for (var issue of state) {
            if (issue.issueKey === action.issueKey) {
                return state;
            }
        }
        return [...state, action];
    }
});
//# sourceMappingURL=add.js.map